import React, {Component} from 'react';
import {
  withError,
  withStyleguide,
  withRouter,
  Loading,
  withJobInformationApi,
  HandleLoading, FormUtility
} from 'cw-styleguide-react';
import i18n from "../../../i18n";
import {route} from "../../../routes";
import JobView from "../views/JobView";
import { withTranslation } from 'react-i18next';

class JobController extends Component {

  /**
   * constructor
   * @param props
   */
  constructor(props) {
    super(props);

    // Initial state.
    this.state = {
      data: null,
      dataLoaded:null,
      messages: new Set()
    };

    // Bindings.
    this.loadJob = this.loadJob.bind(this);
  }

  /**
   * componentDidMount.
   */
  componentDidMount() {
    this.loadJob();
  }

  componentDidUpdate(prevProps, prevState, snapshot) {
    if (prevProps.params.job !== this.props.params.job) {
      this.setState({
        data: null,
        dataLoaded: null
      });
      this.loadJob();
    }

    if (typeof window.initialiseCard === 'function') {
      window.initialiseCard();
    }
  }

  /**
   * Load the job
   */
  loadJob() {

    this.props.jobInformationApiGetJobInformation(this.props.params.job, i18n.language, (response) => {



      // Update the state.
      this.setState({
        data: response.data,
        dataLoaded: true
      });

      // Set language switcher URL.
      this.props.styleguide.setLanguageUrl(route('job', {job: response.data.slugTrans}, this.props.i18n.language === 'cy' ? 'en' : 'cy'));

    }, (error) => {

      let errors = FormUtility.processServerErrors(error, i18n);

      if (error.response.status == 404) {
        this.setState({
          dataLoaded: error.response.status
        })
      } else {
        this.setState({
          messages: errors.messages,
          dataLoaded: false
        })
      }

    })




        // slug: data.slug,
        //   hasIntroduction: !!(data.d8 && data.d8[0] && data.d8[1]),
        //   introductionText: data.d8 && data.d8[1] ? data.d2[1].value : '',
        //   introductionImage: data.d8 && data.d8[0] ? data.d8[0].value : '',
        //   introductionAlt: data.d8 && data.d8[1] ? data.d8[1].value : '',
        //   hasPay: !!(data.d3),
        //   payStart: data.d3 && data.d3[0] ? data.d3[0].value : '',
        //   payEnd: data.d3 && data.d3[1] ? data.d3[1].value : '',
        //   payContent: data.d15,
        //   hasHours: !!(data.d5),
        //   hoursRange: data.d4 && data.d4[0] ? data.d4[0].value : '',
        //   hoursTimetable: data.d5 && data.d5[1] ? data.d5[1].value : '',
        //   hoursExtra: data.d5 && data.d5[2] ? data.d5[2].value : '',
        //   hoursContent: data.d14,
        //   hasQualifications: !!(data.d6),
        //   qualificationsText: data.d6,
        //   qualificationsContent: data.d33,
        //   hasOpenings: !!(data.d7),
        //   openingsCount: data.d7 && data.d7[1] ? data.d7[1].value : '',
        //   openingsImage: data.d7 && data.d7[0] ? data.d7[0].value : '',
        //   openingsText: data.d7 && data.d7[2] ? data.d7[2].value : '',
        //   openingsExtra: data.d7 && data.d7[3] ? data.d7[3].value : '',
        //   hasDemand: !!(data.d28),
        //   demandLevel: data.d28 && data.d28[0] ? data.d28[0].value : '',
        //   demandText: data.d28 && data.d28[1] ? data.d28[1].value : '',
        //   demandExtra: data.d28 && data.d28[2] ? data.d28[2].value : '',
        //   hasBecome: !!(data.d29),
        //   becomeText: data.d29,
        //   becomeContent: data.d16,
        //   hasHealth: !!(data.d9),
        //   healthShow: data.d9 && data.d9[0] ? data.d9[0].value !== 'hide' : false,
        //   healthExtra: data.d9 && data.d9[1] ? data.d9[1].value : '',
        //   healthText: data.d35 && data.d35[1] ? data.d35[1].value : '',
        //   hasHealthLong: !!(data.d19 && data.d9[0].value !== 'hide'),
        //   healthLongText: data.d19,
        //   hasSkills: !!(data.d18),
        //   skillsText: data.d18,
        //   skillsContent: data.d30,
        //   hasSubjects: !!(data.d17),
        //   subjectsText: data.d17,
        //   hasRelated: !!(data.d26),
        //   relatedText: data.d26,
        //   hasLinks: !!(data.d27 && data.d27[0].list),
        //   linksList: data.d27 && data.d27[0] ? data.d27[0].list.map(link => link.item) : [],
        //   hasPrimaryWebsites: hasPrimaryWebsites,
        //   primaryWebsitesList: primaryWebsitesList,
        //   hasSecondaryWebsites: hasSecondaryWebsites,
        //   secondaryWebsitesList: secondaryWebsitesList,
        //   websitesList: [...primaryWebsitesList, ...secondaryWebsitesList],
        //   hasRecommended: !!(data.d31 && data.d31.length),
        //   recommendedText: data.d31,
        //   hasUseful: !!(data.d36 && data.d36.length),
        //   usefulText: data.d36,
        //   roleContent: data.d10,
        //   hasStatistics: !!(data.d24),
        //   statisticsText: data.d24 && data.d24[0] ? [data.d24[0]] : [],
        //   statisticsExtra: data.d24 && data.d24[1] ? data.d24[1].value : '',
        //   dataLoaded:true
        //

  }

  render() {

    return (
        <HandleLoading loading={{loaded:this.state.dataLoaded}} messages={this.state.messages} container={true}>
      <JobView {...this.state} {...this.props}/>
        </HandleLoading>
    );
  }
}

export default withJobInformationApi(withRouter(withTranslation('local')(withStyleguide(withError(JobController)))));
